/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$:
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponseData;

  constructor(
    err:
      PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse";
  }
}

/** @internal */
export const PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$inboundSchema:
  z.ZodType<
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse(
        v,
      );
    });

/** @internal */
export type PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$outboundSchema:
  z.ZodType<
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$Outbound,
    z.ZodTypeDef,
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse
  > = z.instanceof(
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$ {
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$inboundSchema;
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$outboundSchema;
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$Outbound` instead. */
  export type Outbound =
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$Outbound;
}
